import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
    trackOrderSuccess,
    trackOrderFailure,
    reachPlanSuccess,
    reachPlanFailure,
    referalSuccess,
    referalFailure,
    referalGetSuccess,
    referalGetFailure,
    trackOrderGetSuccess,
    trackOrderGetFailure,
} from './actions';
import { TRACK_ORDER, REACH_PLAN, REFERAL, REFERAL_GET, TRACK_ORDER_GET } from './actionTypes';
import apiJunction from '../../utils/api';
import { domainMap, domainName } from '../../config';
import ApiEndPoints from '../../utils/ApiEndPoints';

export interface ResponseGenerator {
    config?: any;
    data?: any;
    headers?: any;
    request?: any;
    status?: number;
    statusText?: string;
}

// track order api
function* trackOrder(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'get',
            url:
                domainName === domainMap.T2
                    ? `${ApiEndPoints.trackOrder}/${action.payload.orderId}`
                    : `${ApiEndPoints.trackOrder}/${action.payload.orderId}?poll=${action.payload.poll}`,
        });
        yield put(
            trackOrderSuccess({
                TrackOrder: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            trackOrderFailure({
                errorTrackOrder: e.response && e.response.data,
            }),
        );
    }
}

// track order api by customer ID
function* trackOrderByCustomerID(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'get',
            url: `${ApiEndPoints.trackOrdertrackOrderByCustomerID}/${action.payload.customerId}`,
        });
        yield put(
            trackOrderGetSuccess({
                TrackOrderGet: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            trackOrderGetFailure({
                errorTrackOrderGet: e.response && e.response.data,
            }),
        );
    }
}

// reach plan api
function* reachPlan(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'get',
            url: `${ApiEndPoints.reachPlan}/${action.payload.plan}`,
        });
        yield put(
            reachPlanSuccess({
                ReachPlan: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            reachPlanFailure({
                errorReachPlan: e.response && e.response.data,
            }),
        );
    }
}

// referal api
function* referal(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'post',
            url: `${ApiEndPoints.referal}`,
            body: action.payload.data,
        });
        yield put(
            referalSuccess({
                Referal: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            referalFailure({
                errorReferal: e.response && e.response.data,
            }),
        );
    }
}

// referal get api by email id
function* referalGet(action: any) {
    try {
        const response: ResponseGenerator = yield call(apiJunction.makeRequest, {
            method: 'get',
            url: `${ApiEndPoints.referal}/${action.payload.emailId}`,
        });
        yield put(
            referalGetSuccess({
                ReferalGet: response.data,
            }),
        );
    } catch (e: any) {
        yield put(
            referalGetFailure({
                errorReferalGet: e.response && e.response.data,
            }),
        );
    }
}

function* InternationalServiceSage() {
    yield all([
        takeLatest(TRACK_ORDER, trackOrder),
        takeLatest(REACH_PLAN, reachPlan),
        takeLatest(REFERAL, referal),
        takeLatest(REFERAL_GET, referalGet),
        takeLatest(TRACK_ORDER_GET,trackOrderByCustomerID),
    ]);
}

export default InternationalServiceSage;
